export interface IUser {

    Id: number;
    Email: string;
    Password: string;
    FirstName: string;
    LastName: string;
    IsActive: boolean;
    CompanyId: number;
    CompanyName: string;
    TenantId: number;
    ContactNo: string;
    OtherContactNo: string;
    CreatedDate: Date;
    UserID: number;
    Rights?: string[];
}



export class User implements IUser {
    constructor(
        public Id: number,
        public Email: string,
        public UserName: string,
        public Password: string,
        public FirstName: string,
        public LastName: string,
        public IsActive: boolean,
        public CompanyId: number,
        public CompanyName: string,
        public TenantId: number,
        public ContactNo: string,
        public OtherContactNo: string,
        public CreatedDate: Date,
        public UserID: number
    ) { }
}

export interface IUserRoleRights {
    Id: number;
    UserName: string;
    FirstName: string;
    LastName: string;
    Email: string;
    IsActive: boolean;
    RoleId: number;
    RoleName: string;
    RoleIsActive: boolean;
    RightId: number;
    RightName: string;
}


// WEBPACK FOOTER //
// E:/sachin/Project/Masterly_Solutions/Project_HRMS/Hrms_Developer/hrms/Peerless.HRMS.WebUI.EmployeePortal/src/app/pages/login/login.ts